<div class="contents-area">
  <div class="column-list">
    <label class="list-input-title">誌面</label>
    <div class="list-input-content">
      <img class="position-relative" src="" id="img_Publish" #img_Publish>
    </div>

    <label class="list-input-title">EC変更前</label>
    <div class="list-input-content">
      <img class="position-relative" src="" id="img_CwsBefore" #img_CwsBefore>
    </div>

    <label class="list-input-title">EC変更後</label>
    <div class="list-input-content">
      <img class="position-relative" src="" id="img_CwsAfter" #img_CwsAfter>
    </div>
  </div>

  <wj-flex-grid [style.width.px]="1019" #dtg_ImageFileList id="dtg_ImageFileList" forcedEnabledMode="true"
    [itemsSource]="kymw5500Model.imageFileList" [headersVisibility]="'Column'" [isReadOnly]="true"
    (selectionChanged)="eventImageFileListSelect_CHANGEHandler()" [tabindex]="0">
    <wj-flex-grid-column [header]="'画像ファイル名'" [minWidth]="5" [width]="225" [binding]="'ImageFileName'">
    </wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="110" [binding]="'Pcode'">
    </wj-flex-grid-column>
    <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="225" [binding]="'GoodsName'">
    </wj-flex-grid-column>
    <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="150" [binding]="'GoodsStandardName'">
    </wj-flex-grid-column>
    <wj-flex-grid-column [header]="'エラーメッセージ'" [minWidth]="5" [width]="290" [binding]="'ErrorMessage'">
    </wj-flex-grid-column>
  </wj-flex-grid>
</div>

<footer class="footer-buttons">
  <button class="btn-primary" id="btn_UpdateImage" #btn_UpdateImage (click)="eventUpdateImage_CLICKHandler()"
    [tabindex]="0">更新</button>
</footer>